// extracted by mini-css-extract-plugin
module.exports = {"dynamicSearchViewWrapper":"DynamicSearch_view_dynamicSearchViewWrapper__QSYex"};